import { Vue, Options } from "vue-class-component";
import { first } from "lodash";
import {
  LCircle,
  LCircleMarker,
  LLayerGroup,
  LMap,
  LMarker,
  LPolygon,
  LPolyline,
  LPopup,
  LRectangle,
  LTileLayer,
  LControlLayers,
  LControl,
  LTooltip
} from "@vue-leaflet/vue-leaflet";
import StatusComponent from "../status/status.vue";
import router from "@/router";
import monitorBloc from "../../services/bloc";
import { ReadingData } from "../../services";
import { MonitorEquipment } from "./model";
import { Subscription } from "rxjs";
import { Watch } from "vue-property-decorator";

@Options({
  props: {
    center: Array,
    equipments: Array,
    isIndex: Boolean,
  },
  components: {
    LCircle,
    LCircleMarker,
    LLayerGroup,
    LMap,
    LMarker,
    LPolygon,
    LPolyline,
    LPopup,
    LRectangle,
    LTileLayer,
    LControlLayers,
    LControl,
    LTooltip,
    StatusComponent,
  },
})
export class BaseMapComponent extends Vue {
  url: string = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
  attribution: string = "Nexus";
  zoom: number = 15;
  center: any = [51.505, -0.159];
  color: any = "warning";
  isExpanded = false;
  isShowControl = false;
  isIndex = false;
  equipments: MonitorEquipment[] = [];
  equipment: MonitorEquipment = new MonitorEquipment();

  colorLib: any = {
    default: {
      background: "#333639",
      border: "#eeeeee",
    },
    success: {
      background: "#18a058",
      border: "#e3f3eb",
    },
    warning: {
      background: "#f0a020",
      border: "#fdf1de",
    },
    error: {
      background: "#d03050",
      border: "#faeaed",
    },
    selected: {
      background: "#5e72e4",
      border: "#5e72e47a",
    },
  };
  subscription: Subscription[] = [];
  willLog = 0;
  get leafletMap() {
    const mapComponent = this.$refs.leafletMap as any;
    return mapComponent?.leafletObject ?? null;
  }

  @Watch("equipments", { immediate: false, deep: true })
  watchEquipments(equipments) {
    equipments.forEach((marker: any, key) => {
      marker.sensors.forEach((sensor, skey) => {
        this.equipments[key].sensors[skey].status = this.setStatus(sensor);
      });
      const sensors = this.equipments[key].sensors;

      this.equipments[key].status = this.statusPriority(sensors);
    });
    if(this.isShowControl) {
      const selected = this.equipments.filter((equipment) => {
        return equipment.id == this.equipment.id;
      });
  
      this.equipment = selected[0];
    }
  }

  statusPriority(sensors: any[]): string {
    const getByStatus = (status) => {
      return sensors
        .filter((sensor) => {
          return !!sensor.status;
        })
        .filter((sensor) => {
          return sensor.status == status;
        });
    };
    const statuses = ["default", "error", "warning", "success"];
    for (const key in statuses) {
      if (getByStatus(statuses[key]).length > 0) {
        return statuses[key];
      }
    }
    return "default";
  }

  setStatus(item: any) {
    if (monitorBloc.isActive(item.last_reading) && item.alarm_type == 78) {
      return "error";
    } else if (
      monitorBloc.isActive(item.last_reading) &&
      item.alarm_type == 77
    ) {
      return "warning";
    } else if (monitorBloc.isActive(item.last_reading)) {
      return "success";
    }
    return "default";
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
    const scope = this;
    const center = scope.leafletMap.getCenter();
    setTimeout(function () {
      scope.leafletMap?.invalidateSize({ pan: false });
      scope.leafletMap.setView(center, scope.leafletMap.getZoom(), {
        animate: false,
      });
    }, 300);
  }

  openStatus(equipmentId) {
    if (!this.isIndex) return;
    if (this.isShowControl && this.equipment.id == equipmentId) return this.closeStatus();
    const selected = this.equipments.filter((equipment) => {
      return equipment.id == equipmentId;
    });

    this.equipment = selected[0];
    this.isShowControl = true;
  }

  closeStatus() {
    this.isShowControl = false;
    this.equipment = new MonitorEquipment
  }

  zoomIn() {
    this.zoom++;
  }

  zoomOut() {
    this.zoom--;
  }

  toView(equipmentId) {
    router.push("/monitor/" + this.equipment.id);
  }
}
